<template>
  <div class="dash-section">
    <div class="header">
      <div class="full-width">
        <h2 class="title">User Mental Health Concerns</h2>
        <p class="body full-width">
          This chart depicts the percentage of registered users who selected
          each concern. Users may identify multiple issues.
        </p>
      </div>
    </div>
    <div
      v-if="loading"
      class="skeleton progress"
      style="height: 296px"
    >
      <span class="sr-only">Loading Chart</span>
    </div>
    <mental-health-concerns-chart
      v-else
      :data="concerns"
      :student-count="registeredStudents"
    />
  </div>
</template>

<script>
import MentalHealthConcernsChart from './MentalHealthConcernsChart.vue';

export default {
  name: 'MentalHealthConcernsSection',

  components: {
    MentalHealthConcernsChart
  },

  inject: ['demographicsReport', 'studentDetailsReport'],

  computed: {
    loading() {
      return this.demographicsReport.loading;
    },

    registeredStudents() {
      return this.demographicsReport.data.totalActiveStudents;
    },
    concerns() {
      return this.demographicsReport.data.concerns;
    }
  }
};
</script>
